const submenu = {
    container: {
        base: "absolute z-[100] top-full shadow-lg bg-white whitespace-nowrap border border-gray-100 rounded-lg"
    },
    overlay: {
        base: 'fixed z-[99] inset-0 bg-slate-800',
        opacity: 'opacity-10'
    },
    items: '-mb-1',
    item: 'flex items-center mb-1 text-sm whitespace-nowrap block px-4 py-2 rounded hover:bg-slate-100 text-gray-700 hover:text-primary'
};

submenu.container.default = `${submenu.container.base} p-2`;
submenu.container.large = `${submenu.container.base} p-4`;

export default submenu;